@if (isUploading) {
  <p-progressSpinner></p-progressSpinner>
}
<form
  aria-label="upload-letter-panel"
  [formGroup]="form"
  [hidden]="isUploading"
  >
  <div class="flex flex-col">
    <div class="flex">
      <label class="field-required font-semibold pr-2 py-2" for="letter-type">
        Select Letter:
      </label>
      <p-select
        appendTo="body"
        autoWidth="false"
        formControlName="letterType"
        id="letter-type"
        optionLabel="documentDisplayName"
        placeholder="Select Letter"
        styleClass="w-[19rem]"
        [options]="letterTypes"
        />
        @if (showAttachButton) {
          <div>
            <mnc-documents-document-upload-select
              class="p-2"
              [accept]="allowedExtensions.join()"
              [maxFileNameSize]="maxFileNameSize"
              [maxFileSize]="maxFileSize"
              [multiple]="false"
              (errorValidation)="onError($event)"
              (selectFiles)="addFile($event)"
            ></mnc-documents-document-upload-select>
          </div>
        }
      </div>
      @if (selectedLetter) {
        <div>
          @if (noLines && (enableLineSelection || !isEligibleForUpload)) {
            <p class="my-4 font-semibold text-red-400">
              {{ getNoLineMessage() }}
            </p>
          } @else {
            <div class="flex gap-2 pr-2 py-4">
              <label class="font-semibold"> Urgency: </label>
                <div class="flex items-center">
                  <p-radio-button
                    formControlName="isUrgent"
                    inputId="urgencyRoutine"
                    name="isUrgent"
                    [value]="false"
                  />
                  <label class="ml-2" for="urgencyRoutine">Routine</label>
                </div>
                <div class="flex items-center">
                  <p-radio-button
                    formControlName="isUrgent"
                    inputId="urgencyUrgent"
                    name="isUrgent"
                    [value]="true"
                  />
                  <label class="ml-2" for="urgencyUrgent">Urgent</label>
                </div>
            </div>
            @if (enableLineSelection) {
              <div class="flex flex-col pb-8">
                <label class="field-required font-semibold py-2">
                  Select the line(s) that apply:
                </label>
                @if (columns) {
                  <mnc-documents-shared-line-select
                    [columns]="columns"
                    [isSingleSelect]="isSingleSelect"
                    [lineData]="filteredLineData"
                    (selectedLines)="handleSelectedLines($event)"
                  />
                }
              </div>
            }
            @if (attachedFiles?.length > 0) {
              <div>
                <label class="font-semibold"> Attached File: </label>
                <div class="pt-4">
                  <p-table responsiveLayout="scroll" [value]="attachedFiles">
                    <ng-template pTemplate="header">
                      <tr>
                        <th style="width: 15rem">File Name</th>
                        <th style="width: 3rem">File Size</th>
                        <th style="width: 7rem">&nbsp;</th>
                      </tr>
                    </ng-template>
                    <ng-template let-file let-ri="rowIndex" pTemplate="body">
                      <tr>
                        <td style="width: 15rem">
                          <span
                            tooltipPosition="bottom"
                            [pTooltip]="file.documentFileName"
                            >
                            {{ file.documentFileName }}
                          </span>
                        </td>
                        <td style="width: 3rem">
                          {{ file.fileMetaData.size }} Bytes
                        </td>
                        <td class="text-right" style="width: 7rem">
                          <button
                            class="p-button-text"
                            icon="pi pi-trash"
                            pButton
                            (click)="resetAttachments()"
                          ></button>
                        </td>
                      </tr>
                    </ng-template>
                  </p-table>
                </div>
              </div>
            }
            <div class="flex pt-4">
              <p class="ml-auto font-semibold text-red-400">
                PHI RISK: Double check the auth number to ensure you are uploading
                the correct member letter
              </p>
            </div>
            <div class="pt-4 flex justify-end upload-button">
              <button
                class="p-button-action"
                label="Upload"
                pButton
                type="button"
            [disabled]="
              attachedFiles?.length !== 1 || (selectedLineIds.length === 0 && (enableLineSelection || !isEligibleForUpload))
            "
                (click)="uploadDocuments()"
              ></button>
            </div>
          }
        </div>
      }
    </div>
  </form>
